import React, {Dispatch, SetStateAction} from "react";
import ModalWrapper from "components/UI/Modal/ModalWrapper";

export interface IModal {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export interface IModalProps extends IModal {}

const Modal: React.FC<IModalProps> = (
    {
        isOpen,
        setIsOpen
    }
) => {
    return (
        <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen}>
            <div onClick={(e) => {
                e.stopPropagation()
            }} className="modal__content how-to-buy-content">
                <button className="modal__btn-close" onClick={() => {setIsOpen(false)}}>Close</button>
                <p className="modal__title">How to Buy an Iggy to Vote?</p>
                <div className="video-container">
                <iframe src="https://www.youtube.com/embed/ips8gSAPPS0" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" frameBorder={0} ></iframe>
                </div>
                
            </div>
        </ModalWrapper>
    );
};

export default Modal;